// extracted by mini-css-extract-plugin
export default {"collapse":"collapse_collapse__wOBso","menu":"collapse_menu__IDttu","navMenu-items":"collapse_navMenu-items__lamHK"};